import * as React from "react";
import { useState } from "react";
import { useMediaQuery } from 'react-responsive'
import AppMobileView from './views/AppMobileView/AppMobileView';
import AppDesktopView from './views/AppDesktopView/AppDesktopView';
import GridPage from './views/GridPage/GridPage';

function App() {
  const isMobile = useMediaQuery({ query: '(max-width: 840px)' })
  const [currentPage, setCurrentPage] = useState('main'); // 'main' or 'grid'

  const handleNavigate = (page) => {
    setCurrentPage(page);
    window.scrollTo(0, 0); // Scroll to top when switching pages
  };

  return (
    <div>
      {currentPage === 'main' ? (
        isMobile
          ? <AppMobileView onNavigate={handleNavigate} />
          : <AppDesktopView onNavigate={handleNavigate} />
      ) : (
        <GridPage onNavigate={handleNavigate} />
      )}
    </div>
  );
}

export default App;
